import { Stack, StackProps, alpha, styled } from '@mui/material';
import { ReactNode } from 'react';
import { useDropzone } from 'react-dropzone';
import { UploadProps } from './types';

export const UploadDropzone = ({
  children,
  sx,
  allowClick = false,
  className,
  onClick,
  ...uploadProps
}: UploadProps & {
  children: ReactNode;
  allowClick?: boolean;
  className?: string;
  onClick?: () => void;
} & Pick<StackProps, 'sx'>) => {
  const { getRootProps, isDragActive, open } = useDropzone({
    ...uploadProps,
  });
  return (
    <Stack
      sx={{ ...sx, position: 'relative' }}
      {...getRootProps()}
      onClick={allowClick ? open : onClick}
      className={className}
    >
      {children}
      {isDragActive && <StyledOverlay />}
    </Stack>
  );
};

const StyledOverlay = styled('div')(({ theme }) => ({
  position: 'absolute',
  inset: 0,
  backgroundColor: alpha(theme.palette.primary.main, 0.08),
  border: `solid 1px ${theme.palette.divider}`,
  borderColor: alpha(theme.palette.secondary.main, 0.24),
  bgcolor: alpha(theme.palette.primary.main, 0.08),
  boxShadow: theme.customShadows.z20,
}));
